import { SelectableWithIdObject } from "src/components/Form/types";

export type BasicResponse = {
  ok: boolean;
};

export interface PersonResponse {
  id: number;
  fullname: string;
}

export interface IIdentifiable {
  id: number;
  getUniqueIdentifier(): string;
}

export class Person extends SelectableWithIdObject implements IIdentifiable {
  public fullName: string;

  constructor(data: PersonResponse) {
    super(data.id);
    this.fullName = data.fullname;
  }

  getDisplayName(): string {
    return `(${this.id}) ${this.fullName}`;
  }

  getUniqueIdentifier(): string {
    return `${this.id}:${this.fullName}`;
  }
}

export const mapPerson = (data: PersonResponse): Person => {
  return new Person(data);
};

export const removeDuplicates = <T extends IIdentifiable>(items: T[] | undefined | null): T[] =>
  items?.filter(
    (current, currentIndex) =>
      currentIndex === items.findIndex((item) => item.getUniqueIdentifier() === current.getUniqueIdentifier()),
  ) ?? [];
